(function () {
  function closeMenuDrawer() {
    var drawerDetails = document.querySelector('header-drawer details');
    if (drawerDetails && drawerDetails.hasAttribute('open')) {
      drawerDetails.removeAttribute('open');
    }
    document.body.classList.remove('overflow-hidden', 'menu-open');
    document.querySelectorAll('#menu-drawer details[open]').forEach(function (el) {
      el.removeAttribute('open');
    });
  }

  document.addEventListener(
    'click',
    function (e) {
      var link = e.target.closest('.menu-drawer a.menu-drawer__menu-item[href]');
      if (!link) return;
      var href = link.getAttribute('href');
      if (!href || href === '#' || href.indexOf('javascript:') === 0) return;
      closeMenuDrawer();
    },
    true
  );

  function fixHeroBackground() {
    var banner = document.querySelector('.petousis-hero-banner');
    if (!banner) return;

    var img = banner.querySelector('.petousis-hero-banner__image');
    var bg = banner.querySelector('.petousis-hero-banner__bg');

    if (img) {
      img.style.display = 'block';
      return;
    }

    if (!bg) return;

    bg.style.display = 'block';

    var match = (bg.style.backgroundImage || '').match(/url\(["']?([^"')]+)/);
    if (!match || !match[1]) return;

    var heroImg = document.createElement('img');
    heroImg.className = 'petousis-hero-banner__image';
    heroImg.src = match[1];
    heroImg.alt = bg.getAttribute('aria-label') || 'Petousis Tools';
    heroImg.width = 1920;
    heroImg.height = 960;
    heroImg.loading = 'eager';
    heroImg.setAttribute('fetchpriority', 'high');
    banner.insertBefore(heroImg, bg);
    bg.remove();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', fixHeroBackground);
  } else {
    fixHeroBackground();
  }

  function setupOpencartDrawerPortal() {
    var header = document.querySelector('[class*="ai-opencart-header"]');
    if (!header) return;

    var drawer = header.querySelector('[class*="ai-opencart-header__menu-drawer"]');
    var overlay = header.querySelector('[class*="ai-opencart-header__overlay"]');
    if (!drawer || !overlay) return;

    if (!drawer.dataset.petousisPortaled) {
      drawer.dataset.petousisPortaled = '1';
      overlay.dataset.petousisPortaled = '1';
      document.body.appendChild(overlay);
      document.body.appendChild(drawer);
    }

    var sync = function () {
      document.body.classList.toggle(
        'petousis-menu-open',
        drawer.classList.contains('active')
      );
    };

    new MutationObserver(sync).observe(drawer, {
      attributes: true,
      attributeFilter: ['class'],
    });
    sync();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setupOpencartDrawerPortal);
  } else {
    setupOpencartDrawerPortal();
  }
})();
